import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'environments/environment';

import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ClienteService {
	private url_grupo_2e: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public post(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url_grupo_2e}cliente`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}


	public put(data: any, id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url_grupo_2e}cliente/${id}`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public delete(id: number): Observable<any> {
		return this.http
			.put<any>(`${this.url_grupo_2e}cliente/delete/${id}`, {
				id_cliente: id,
				isDeleted: 1,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public get(): Observable<Array<any>> {
		return this.http.get<Array<any>>(`${this.url_grupo_2e}cliente`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getOne(id: number): Observable<any> {
		return this.http.get<any>(`${this.url_grupo_2e}cliente/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getCpf(documento: number): Observable<any> {
		return this.http
			.get<any>(`${this.url_grupo_2e}cliente/getCpf/${documento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getCity(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url_grupo_2e}cliente/getCity/${data}`, {}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getCityByInitial(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url_grupo_2e}cliente/getCityByInitial/${data}`, {}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public exportarClienteRastreei(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url_grupo_2e}rastreei/integrar`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public insertIntegracaoUsuario(
		id_sistema: number,
		id_cliente: number,
		id_cliente_integracao: number
	): Observable<any> {
		return this.http
			.post<any>(`${this.url_grupo_2e}cliente/insertIntegracaoUsuario`, {
				id_sistema: id_sistema,
				id_cliente: id_cliente,
				id_usuario_integracao: id_cliente_integracao
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public consultarLoginRastreei(user: any): Observable<any> {
		return this.http
			.post<any>(`${this.url_grupo_2e}cliente/consultarLoginRastreei`, {
				user: user,
			}, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public consultaIntegracaoUsuario(id: any): Observable<any> {
		return this.http
			.get<any>(`${this.url_grupo_2e}cliente/integracao/${id}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public pesquisa(param: string): Observable<any> {
		return this.http
			.get<any>(`${this.url_grupo_2e}cliente/pesquisa/${param}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getClienteRastreeiByCpfCnpj(cpf_cnpj_cliente: string, nome_contratante: string): Observable<any> {
		return this.http
			.get<any>(`${this.url_grupo_2e}rastreei/clientes?cpf_cnpj=${cpf_cnpj_cliente}&nome=${nome_contratante}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}
}
